import React from 'react';
import Card from '../../../common/components/Card';
import { getStateName, getLocationText } from '../utils';


export const EventCard = ({
  event,
  imageUrl,
  onEventFullClick,
}) => 
  <Card
    bubbleText={getStateName(event)}
    title={event.title}
    subtitle={[event.displayDate, getLocationText(event)]}
    imageUrl={event.imageUrl}
    primaryButtonText={'Register'}
    primaryButtonTo={event.numberOfSeatsAvailable !== 0 ? `/events/${event.key}/register` : null}
    primaryButtonOnClick={event.numberOfSeatsAvailable !== 0 ? null : onEventFullClick}
    secondaryButtonText={'View More'}
    secondaryButtonTo={`/events/${event.key}`}
  />;

export default EventCard;


// WEBPACK FOOTER //
// ./src/App/events/components/EventCard.js